import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Flex,
  Text,
} from '@retracedgmbh/ui-components-lib';
import type React from 'react';
import useTranslator from '@/hooks/useTranslator';

interface CancelAnalysisDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  assetName: string;
  onConfirm: () => void;
  variant?: 'cancel' | 'dismissReview';
}

export default function CancelAnalysisDialog({
  open,
  onOpenChange,
  assetName,
  onConfirm,
  variant = 'cancel',
}: CancelAnalysisDialogProps): React.JSX.Element {
  const { getTranslation } = useTranslator({ page: 'ai-processing' });
  const prefix =
    variant === 'dismissReview' ? 'dismissReview' : 'cancelAnalysis';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {getTranslation(`${prefix}.title`, { assetName })}
          </AlertDialogTitle>
        </AlertDialogHeader>
        <Flex direction='column' gap='md' paddingY='xl'>
          <Text as='p' size='base' color='secondary'>
            {getTranslation(`${prefix}.description1`)}
          </Text>
          <Text as='p' size='base' color='secondary'>
            {getTranslation(`${prefix}.description2`)}
          </Text>
        </Flex>
        <AlertDialogFooter className='tw:gap-md'>
          <AlertDialogCancel>
            {getTranslation(`${prefix}.continue`)}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {getTranslation(`${prefix}.confirm`)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
